import { LoadingSkeleton } from '@bloomfieldrobotics/canopy';
import { TableRow } from '@mui/material';
import { useCallback, useState } from 'react';
import { useVariety } from '../../../../services/entities/hooks/useVariety';
import { Block } from '../../../../services/entities/impl/blfApi/schemas/block';
import { SettingsTableCell } from '../../components/SettingsTableCell';
import { VarietySelect } from './VarietySelect';

type Props = {
  block: Block;
  customerId: string;
  onVarietyChange: (blockId: string, varietyId: string) => void;
};

export const BlockTableRow = ({
  block,
  customerId,
  onVarietyChange,
}: Props) => {
  const { variety, isVarietyLoading } = useVariety(block.varietyID);
  const [selectedVariety, setSelectedVariety] = useState(block.varietyID);

  const handleVarietyChange = useCallback(
    (varietyId: string) => {
      setSelectedVariety(varietyId);
      onVarietyChange(block.id, varietyId);
    },
    [block, onVarietyChange]
  );

  const cropType = variety?.cropType;

  return (
    <TableRow key={block.id}>
      <SettingsTableCell>{block.name}</SettingsTableCell>
      <SettingsTableCell>
        <LoadingSkeleton loading={isVarietyLoading}>
          <VarietySelect
            customerId={customerId}
            value={selectedVariety}
            onChange={handleVarietyChange}
            cropType={cropType}
          />
        </LoadingSkeleton>
      </SettingsTableCell>
    </TableRow>
  );
};
